namespace $ {

	const $shm_hitalama_baza_saving_installed = new WeakSet< object >

	/** Never cache the unsaved queue while its units are still being signed. */
	export function $shm_hitalama_baza_saving_install( Land = $giper_baza_land ) {
		const proto = Land.prototype
		if( $shm_hitalama_baza_saving_installed.has( proto ) ) return
		$shm_hitalama_baza_saving_installed.add( proto )
		const native = ( proto.units_unsaved as typeof proto.units_unsaved & {
			orig?: typeof proto.units_unsaved
		} ).orig ?? proto.units_unsaved
		$mol_mem( proto, 'units_unsaved', { value: function( this: $giper_baza_land ) {
			// Giper's seal index is not reactive. An early queue read otherwise
			// caches [] before signing and omits new fields from local persistence.
			// Keep the native queue/save implementation and its normal sync root.
			this.units_signing()
			return native.call( this )
		} } )
	}

}
